import React from 'react';
import { Phone, ArrowRight } from 'lucide-react';
export function MobileStickyCTA() {
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 flex gap-2 px-2 pt-2 pb-2 bg-white/95 backdrop-blur-md border-t border-stone-200 shadow-[0_-8px_24px_-8px_rgba(0,0,0,0.12)]" style={{
    paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))'
  }} data-id="element-457">
      <a href="tel:+61864043888" className="flex-1 flex items-center justify-center gap-2 h-12 rounded-xl bg-brand text-white font-bold text-[15px] shadow-md active:scale-[0.98] transition-transform" aria-label="Call Langler Air on 08 6404 3888" data-id="element-458">
        <Phone size={16} strokeWidth={2.5} data-id="element-459" />
        Call Mike
      </a>
      <a href="#quote-form" className="flex-1 flex items-center justify-center gap-1.5 h-12 rounded-xl bg-accent text-ink-900 font-bold text-[15px] shadow-md active:scale-[0.98] transition-transform" data-id="element-460">
        Free Quote
        <ArrowRight size={15} strokeWidth={2.5} data-id="element-461" />
      </a>
    </div>;
}